export const BREAK_TABLET = 1024;

export const HOST_LISTENER_EVENTS = {
  RESIZE: 'window:resize',
  SCROLL: 'window:scroll',
  MOUSE: {
    ENTER: 'mouseenter',
    OUT: 'mouseout',
    OVER: 'mouseover'
  }
};

export const HEADER_TITLE_HEIGHT = 60;
export const BOOKING_PAYMENT_DETAIL_STICKY_OOFSET = 181;

export const OVERFLOW_HIDDEN = 'hidden';
export const OVERFLOW_AUTO = 'auto';
